import ReactDOM from "react-dom/client";
import App from "./App";

import { Provider } from "react-redux";

import store from "./Reducers/store";
import { ThemeProvider } from "@nocios/presentation-kit";

import "./Assets/css/index.css";
import "@nocios/presentation-kit/dist/Assets/Fonts/index.css";

import setCurrentPage from "src/Utils/setCurrentPage";
import Logo from "./Component/Logo";
import HeaderCenter from "./Component/HeaderCenter";
import HeaderRight from "./Component/HeaderRight";

import Preload from "./Component/Preload";
import "./Assets/css/fonts.css";
import "./Assets/css/font-inter.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const data = {
  base: {
    showHeaderShadow: false,
  },
  template: {
    "main-template": {
      styleTitle: {
        color: "#fff",
        fontFamily: "Tungsten",
        fontSize: "var(--width-48)",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "normal",
      },
      styleDescription: {
        color: "#fff",
        fontFamily: "Myriad Pro",
        fontSize: "var(--width-20)",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "150%",
        marginTop: "var(--width-36)",
      },
      styleBody: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        marginTop: "var(--width-60)",
      },
    },
  },
  Button: {
    base: {
      fontFamily: "Tungsten",
      fontSize: "var(--width-32)",
      background: "transparent",
      textTransform: "uppercase",
      padding: "var(--width-2) var(--height-26)",
      height: "var(--width-56)",
      border: "1px solid transparent",
      justifyContent: "center",
      borderRadius: "var(--width-185)",
    },
    next: {
      background: "#fff",
      color: "#111",
    },
    back: {
      border: "1px solid #fff",
      color: "white",
    },
  },
};

const globalData = {
  header: {
    logo: <Logo />,
    rightSide: <HeaderRight />,
    centerSide: <HeaderCenter />,
    onClick: () => setCurrentPage(0),
  },
};

root.render(
  <Provider store={store}>
    <Preload>
      <ThemeProvider themeStyles={data} globalData={globalData} setPage={setCurrentPage}>
        <App />
      </ThemeProvider>
    </Preload>
  </Provider>
);
